<template>
  <div>
    <div class="bg-float-default-low grid h-56 place-items-center">Log in</div>
  </div>
</template>
